/**
 * login模块接口列表
 */
import axios from '@/axios/http';

const login = {
  //获取指定用户菜单
  getMenus(roleId,type) {
    return axios.get('/menus?roleId='+roleId+'&isDivide='+type);
  },
  //去登录
  toLogin(params) {
    return axios.post('/tokens', params);
  },
  //退出
  logOut(params) {
    return axios.delete('/tokens');
  },
  //修改密码
  changePwd(params) {
    return axios.put(`/users/user/${params.id}/updatePassword?password=`+params.password);
  },
  //获取登录日志
  getLogsList(params) {
    return axios.get('/logs', {params});
  },

};

export default login;



// WEBPACK FOOTER //
// ./src/api/loginApi.js